// extracted by mini-css-extract-plugin
export default {"bottom":"ErrorPage_bottom__WZFkz","content":"ErrorPage_content__XLagk","top":"ErrorPage_top__ns7Ez","fragno1Logo":"ErrorPage_fragno1Logo__b4Ueb"};